// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Pyn1","actions":"GroupTable_actions__2CSqQ","deleteModalFooter":"GroupTable_deleteModalFooter__7gTgT"};